import { Box, FormControl, FormLabel, Input, Textarea, Text } from '@chakra-ui/react'

export function ExtraFields({ observacao, setObservacao, quantidade, setQuantidade, selectedItem }) {
  const maxQuantidade = selectedItem?.quantidade || 1

  const handleQuantidadeChange = (e) => {
    const value = parseInt(e.target.value, 10) || 0
    setQuantidade(Math.min(value, maxQuantidade))
  }

  return (
    <Box mb={6} p={6} shadow="md" borderWidth="1px" borderRadius="lg" bg="#3a4a53" color="white">
      <Text fontSize="lg" fontWeight="bold" mb={4}>
        Informações da Troca
      </Text>

      <FormControl isRequired mb={4}>
        <FormLabel>Quantidade para Troca</FormLabel>
        <Input
          type="number"
          value={quantidade}
          onChange={handleQuantidadeChange}
          placeholder="Informe a quantidade"
          min={1}
          max={maxQuantidade}
          bg="#4a5a64"
          focusBorderColor="#37F091"
        />
        <Text fontSize="sm" color="gray.400" mt={1}>
          Quantidade máxima disponível: {maxQuantidade}
        </Text>
      </FormControl>

      <FormControl isRequired>
        <FormLabel>Observação</FormLabel>
        <Textarea
          placeholder="Descreva o motivo da troca"
          value={observacao}
          onChange={(e) => setObservacao(e.target.value)}
          rows={4}
          bg="#4a5a64"
          focusBorderColor="#37F091"
        />
        <Text fontSize="sm" color="gray.400" mt={1}>
          Informe detalhes sobre o problema com o produto
        </Text>
      </FormControl>
    </Box>
  )
}
